export function linesToText(lines) {
  return Array.isArray(lines) ? lines.join('\n') : '';
}

export function textToLines(text) {
  if (text === undefined || text === null) return [];
  return String(text).split('\n');
}

export function getSymptomManualFromDb(symptoms, symptomName, lang) {
  const isEn = lang === 'en';
  const record = symptoms.find((s) => (isEn ? s.ename : s.jname) === symptomName);
  const manual = record?.manual?.[isEn ? 'en' : 'ja'];
  if (!manual) return null;
  const hasContent =
    (manual.observation?.length || 0) > 0 ||
    (manual.emergancyTransport?.length || 0) > 0 ||
    (manual.response?.length || 0) > 0;
  return hasContent ? manual : null;
}

export function getSymptomManualFromJson(symptomsJson, symptomName) {
  let result = null;
  symptomsJson.forEach((entry) => {
    const key = Object.keys(entry)[0];
    if (key === symptomName) {
      const data = entry[key];
      result = {
        observation: data?.observation || [],
        emergancyTransport: data?.emergancyTransport || [],
        response: data?.response || [],
      };
    }
  });
  return result;
}

export function resolveSymptomManual(symptoms, symptomsJson, symptomName, lang) {
  return (
    getSymptomManualFromDb(symptoms, symptomName, lang) ||
    getSymptomManualFromJson(symptomsJson, symptomName) || {
      observation: [],
      emergancyTransport: [],
      response: [],
    }
  );
}
